<template>
  <div class="home-page">
    <section class="hero-card">
    </section>

    <section class="content-card">
      <div class="section-header">
        <!-- <span>信息文案</span> -->
        <h2>业务范围</h2>
      </div>
      <p>
        公司依托大数据处理、微服务、容器化部署、系统集成等核心能力，打造面向运营商的互联网信息服务一体化解决方案。
        为运营商提供从前端触点、业务受理、系统保障到数据赋能的端到端服务闭环。构建覆盖网厅、WAP厅、微信营业厅、短信营业厅、代理商系统等多终端受理渠道。围绕产商品管理、号卡资源管理、订单管理、物流管理、用户管理、代理商管理、佣金管理、财务管理等关键环节，打通从营销获客、业务办理、资源调度到财务结算的完整链路。
        通过全渠道协同与多元分销体系的有效支撑，助力运营商实现规模化拓展与精细化运营。
      </p>
    </section>

    <div class="content">
    <section class="service-section">
        <div class="container">
            <div class="section-header">
                <span class="section-label">Operator Services</span>
                <h2 class="section-title">运营商业务</h2>
                <p class="section-desc">为运营商提供全方位的业务支撑与服务保障</p>
            </div>
            <div class="cards-grid">
                <div class="service-card">
                    <div class="service-icon">
                        <i class="fas fa-chart-bar"></i>
                    </div>
                    <h3 class="service-title">数据驱动运营</h3>
                    <p class="service-desc">建立面向海外业务的数据分析能力，为运营商提供运营洞察与优化建议，助力精细化运营</p>
                </div>
                <div class="service-card">
                    <div class="service-icon">
                        <i class="fas fa-microchip"></i>
                    </div>
                    <h3 class="service-title">技术融合能力</h3>
                    <p class="service-desc">将大数据、AI等技术能力与运营商业务场景深度融合，为合作伙伴提供更具竞争力的服务支撑</p>
                </div>
                <div class="service-card">
                    <div class="service-icon">
                        <i class="fas fa-award"></i>
                    </div>
                    <h3 class="service-title">品牌信誉积累</h3>
                    <p class="service-desc">多年海外市场深耕，在运营商群体中积累良好口碑，成为客户信赖的长期合作伙伴</p>
                </div>
                <div class="service-card">
                    <div class="service-icon">
                          <span class="service-icon__text">￥</span>
                    </div>
                    <h3 class="service-title">成本优化能力</h3>
                    <p class="service-desc">通过规模化交付与流程标准化，帮助运营商有效控制运营成本，提升投入产出比</p>
                </div>
            </div>
        </div>
    </section>

      <section class="ai-section">
        <div class="container">
          <div class="section-header">
              <span class="section-label blue">AI Services</span>
              <h2 class="section-title">运营商AI智能服务</h2>
              <p class="section-desc">基于大语言模型技术，提供智能化、自动化的服务能力</p>
          </div>
          <div class="cards-grid">
              <div class="ai-card">
                  <div class="ai-icon">
                      <i class="fas fa-comments"></i>
                  </div>
                  <h3 class="ai-title">大模型驱动</h3>
                  <p class="ai-desc">依托大语言模型技术，支持多语言、多轮对话，精准理解用户意图，问答响应高效精准</p>
              </div>
              <div class="ai-card">
                  <div class="ai-icon">
                      <i class="fas fa-sync-alt"></i>
                  </div>
                  <h3 class="ai-title">全流程闭环</h3>
                  <p class="ai-desc">从需求识别、套餐推荐到订单核验，支持线上AI智能体与线下机器人双渠道协同，缩短办理周期，提升转化效率</p>
              </div>
              <div class="ai-card">
                  <div class="ai-icon">
                      <i class="fas fa-shield-alt"></i>
                  </div>
                  <h3 class="ai-title">智能运维保障</h3>
                  <p class="ai-desc">从状态监控、故障预警到自动化处置，实现7×24小时系统可观测性，保障业务连续稳定</p>
              </div>
              <div class="ai-card">
                  <div class="ai-icon">
                      <i class="fas fa-eye"></i>
                  </div>
                  <h3 class="ai-title">数据实时洞察</h3>
                  <p class="ai-desc">支持核心指标的实时呈现与多维分析，助力业务人员快速掌握运营状态</p>
              </div>
          </div>
        </div>
      </section>
    </div>
    

  </div>
</template>

<style lang="scss" scoped>
.home-page {
  display: grid;
  // gap: 24px;
}

.hero-card,
.content-card {
  
}

.hero-card {
  padding: 34px;
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  // gap: 24px;
  height: 450px;
  align-items: center;
  background:pink;
  background: url(@/assets/banner.png) no-repeat center center;
  background-size: cover;
}
.content-card {
  width: 1400px;
  margin: 0 auto;
  margin-top: 64px;
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 28px;
  box-shadow: var(--shadow-main);
}

.hero-copy__tag {
  
  display: inline-flex;
  padding: 8px 14px;
  border-radius: 999px;
  margin-bottom: 18px;
  font-size: 13px;
  color: var(--primary);
  background: rgba(17, 88, 214, 0.1);
}

h1 {
  margin: 0 0 16px;
  font-size: 38px;
  line-height: 1.35;
}

p {
  margin: 0;
  font-size: 16px;
  line-height: 1.9;
  color: var(--text-secondary);
}

.hero-banner {
  min-height: 300px;
  border-radius: 24px;
  display: grid;
  place-items: center;
  font-size: 42px;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 2px;
  background: linear-gradient(135deg, #ef2f2f, #c31818);
}

.content-card {
  padding: 34px;
}

.section-header {
  // margin-bottom: 18px;
}

.section-header span {
  display: inline-flex;
  margin-bottom: 8px;
  font-size: 13px;
  // color: #00C9FF;
}

.section-header h2 {
  margin: 0;
  font-size: 28px;
}

@media (max-width: 900px) {
  .hero-card {
    // grid-template-columns: 1fr;
  }

  h1 {
    font-size: 30px;
  }

  .hero-banner {
    min-height: 220px;
    font-size: 32px;
  }
}

@media (max-width: 768px) {
  .hero-card,
  .content-card {
    // padding: 22px;
    border-radius: 20px;
  }

  p {
    font-size: 15px;
  }
}
.service-section {
            padding: 60px 0;
        }
        .section-header {
            text-align: center;
            margin-bottom: 24px;
        }
        .section-label {
            font-size: 0.85rem;
            text-transform: uppercase;
            letter-spacing: 2px;
            font-weight: 600;
            color: #00C9FF;
            margin-bottom: 12px;
            display: block;
        }
        .blue {
          color: #00EACB;
        }
        .section-title {
            font-size: 2.2rem;
            font-weight: 700;
            color: #0f172a;
            margin-bottom: 16px;
        }
        .section-desc {
            font-size: 1rem;
            color: #64748b;
            max-width: 600px;
            margin: 0 auto;
        }

        /* 卡片网格 */
        .cards-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 24px;
        }
        .service-card {
            background: white;
            border-radius: 1.5rem;
            padding: 32px;
            border: 1px solid #eef2ff;
            transition: all 0.3s;
        }
        .service-card:hover {
            transform: translateY(-4px);
            box-shadow: 0 12px 28px rgba(37, 99, 235, 0.08);
            border-color: #00C9FF;
        }
        .service-icon {
            width: 56px;
            height: 56px;
            background: linear-gradient(135deg, #e0f2fe, #eef2ff);
            border-radius: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;
        }
        .service-icon i {
            font-size: 28px;
            color: #00C9FF;
        }
        .service-icon__text {
            font-size: 28px;
            font-weight: 700;
            line-height: 1;
            color: #00C9FF;
        }
        .service-title {
            font-size: 1.25rem;
            font-weight: 600;
            color: #0f172a;
            margin-bottom: 12px;
        }
        .service-desc {
            font-size: 0.95rem;
            color: #64748b;
            line-height: 1.6;
        }
        .ai-section {
            // background: linear-gradient(135deg, #f8fafc 0%, #f0f7ff 100%);
            padding-bottom: 30px;
        }
        .ai-card {
            background: white;
            border-radius: 1.5rem;
            padding: 32px;
            border: 1px solid #eef2ff;
            transition: all 0.3s;
        }
        .ai-card:hover {
            transform: translateY(-4px);
            box-shadow: 0 12px 28px rgba(37, 99, 235, 0.08);
            border-color: #00EACB;
        }
        .ai-icon {
            width: 56px;
            height: 56px;
            background: linear-gradient(135deg, #f3e8ff, #e0e7ff);
            border-radius: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;
        }
        .ai-icon i {
            font-size: 28px;
            color: #00EACB;
        }
        .ai-title {
            font-size: 1.25rem;
            font-weight: 600;
            color: #0f172a;
            margin-bottom: 12px;
        }
        .ai-desc {
            font-size: 0.95rem;
            color: #64748b;
            line-height: 1.6;
        }
        .content {
          width: 1400px;
          margin: 0 auto;
        }
</style>
